import React, { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

export const CopyButton = ({ text, label = "Copy", className = "", size = "sm" }) => {
  const [copied, setCopied] = useState(false);

  const onClick = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(
        typeof text === "string" ? text : JSON.stringify(text, null, 2)
      );
      setCopied(true);
      toast.success("Copied to clipboard");
      setTimeout(() => setCopied(false), 1800);
    } catch (err) {
      toast.error("Copy failed");
    }
  };

  const sizing =
    size === "xs"
      ? "h-7 px-2 text-[11px]"
      : size === "md"
      ? "h-9 px-3 text-xs"
      : "h-8 px-2.5 text-xs";

  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="copy-text-button"
      className={`inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-zinc-900/60 ${sizing} font-medium uppercase tracking-[0.12em] text-zinc-400 transition-all duration-200 hover:border-amber-500/50 hover:text-amber-400 hover:-translate-y-[1px] ${className}`}
      aria-label={label}
    >
      {copied ? <Check className="h-3.5 w-3.5" strokeWidth={2} /> : <Copy className="h-3.5 w-3.5" strokeWidth={1.8} />}
      <span>{copied ? "Copied" : label}</span>
    </button>
  );
};

export default CopyButton;
